import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore"; // Firestore methods
import { db } from "../../firebase"; // Firestore instance
import "./Main.css";

const Main = () => {
  const [formData, setFormData] = useState({
    name: "",
    country: "",
    phone: "",
    pickupAddress: "",
    destination: "",
    vehicle: "camry", // Default vehicle
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      // Save booking data to Firestore
      await addDoc(collection(db, "bookings"), {
        ...formData,
        timestamp: new Date(),
        read: false, 
      });

      alert("Booking request successfully submitted!");
      setFormData({
        name: "",
        country: "",
        phone: "",
        pickupAddress: "",
        destination: "",
        vehicle: "camry",
      });
    } catch (err) {
      console.error("Error saving data to Firestore:", err);
      setError("Failed to book taxi. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="main">
      <div className="left">
        <h1>Book Your Umrah Taxi Instantly</h1>
        <p>Fast, Reliable, and Affordable Taxi Services</p>
      </div>
      <div className="right">
        <form onSubmit={handleSubmit} className="booking-form">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="country"
            placeholder="Country"
            value={formData.country}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="pickupAddress"
            placeholder="Pickup Address"
            value={formData.pickupAddress}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="destination"
            placeholder="Destination"
            value={formData.destination}
            onChange={handleChange}
            required
          />
          <div className="vehicle-dropdown">
            <label htmlFor="vehicle">Select Vehicle:</label>
            <select
              id="vehicle"
              name="vehicle"
              value={formData.vehicle}
              onChange={handleChange}
            >
              <option value="camry">CAMRY</option>
              <option value="hiace">HIACE</option>
              <option value="gmc-yukon">GMC YUKON</option>
              <option value="h1-hundai">H1 HUNDAI</option>
              <option value="coaster">COASTER</option>
              <option value="staria">STARIA</option>
            </select>
          </div>
          {error && <p style={{ color: "red" }}>{error}</p>}
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Booking..." : "Book Taxi"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Main;
